/// <amd-module name="SuiteCommerce.ProductLeadTime.Utils"/>
define("SuiteCommerce.ProductLeadTime.Utils", ["require", "exports", "Utils"], function (require, exports, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.translate = function (string) {
            return Utils_1.translate(string);
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
